import { Box } from "@mui/material";
import { messaging } from "JS/Helpers/UserMessaging";
import { AppTypography } from "JS/React/Components/AppTypography";

export const IncomeDisclosureOfflineNotice = () => (
    <Box
        height={"100vh"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        textAlign={"center"}
        padding={2}
    >
        <AppTypography textColor="black" variant="h6">
            {messaging.incomeDisclosure.unavailableOffline}
        </AppTypography>
    </Box>
);
